import { Grid, Typography } from '@mui/material';
import { getConfirmations } from 'API';
import { getDisabilityConfirmationPdf } from 'API/disabilityConfirmation';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useParams } from 'react-router-dom';
import { downloadFile } from 'Utils';

export const Confirmations = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Confirmations);
  const params = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const exportToPdf = async () => {
    const path = params.docType;
    if (path) {
      if (path.length > 1) {
        const docData = await getConfirmations(path);
        if (docData) {
          downloadFile(docData, '.pdf', path, false);
        }
      } else {
        const fileName = queryParams.get('file') || '';
        const docData = await getDisabilityConfirmationPdf(parseInt(path));
        if (docData) downloadFile(docData, '.pdf', fileName, false);
        else alert(Dictionary[DICTIONARY.TestMenu].errorCreatingFile);
      }
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    exportToPdf();
  }, []);

  return (
    <>
      <Helmet>
        <title>{dictionary.title}</title>
      </Helmet>
      <Grid container justifyContent='center' alignItems='center' height='25vh'>
        <Typography
          variant='h1'
          color='#39546A'
          fontWeight={700}
          textAlign={'center'}
          tabIndex={0}
        >
          {dictionary.downloadWillStartAuto}
        </Typography>
      </Grid>
    </>
  );
};
